export const config = {
  resolveTimeout: 500
};
